var _excluded = ["bgColor", "children", "className", "elevation", "marginBottom", "marginLeft", "marginRight", "marginTop", "padding"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import classnames from 'classnames';
import BackgroundProvider from "../BackgroundProvider";
import StyledBox from "./styled";
import { useTheme } from 'styled-components';
import { useBrand } from "../BrandProvider";

/**
 * Documentation:
 *
 * - [Link for Windows (On-prem)](https://pages.ghe.service.group/constellation/docs/components/box)
 **/
var Box = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$bgColor = _ref.bgColor,
    bgColorProp = _ref$bgColor === void 0 ? 'default1' : _ref$bgColor,
    children = _ref.children,
    customClass = _ref.className,
    _ref$elevation = _ref.elevation,
    elevation = _ref$elevation === void 0 ? 0 : _ref$elevation,
    _ref$marginBottom = _ref.marginBottom,
    marginBottom = _ref$marginBottom === void 0 ? '05' : _ref$marginBottom,
    _ref$marginLeft = _ref.marginLeft,
    marginLeft = _ref$marginLeft === void 0 ? 'none' : _ref$marginLeft,
    _ref$marginRight = _ref.marginRight,
    marginRight = _ref$marginRight === void 0 ? 'none' : _ref$marginRight,
    _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? 'none' : _ref$marginTop,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? 'default' : _ref$padding,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = useBrand() || {},
    brand = _ref2.brand;
  var theme = useTheme() || {};
  var className = classnames('csl-box', customClass);
  var bgColor = bgColorProp;

  /** Deprecation fallbacks for light/dark background colours */

  /* @ts-ignore */
  if (bgColor === 'dark1') {
    bgColor = 'brand1';
  }

  /* @ts-ignore */
  if (bgColor === 'dark1alpha') {
    bgColor = 'overlay';
  }

  /* @ts-ignore */
  if (bgColor === 'dark2') {
    bgColor = 'brand2';
  }

  /* @ts-ignore */
  if (bgColor === 'dark3') {
    bgColor = 'brand3';
  }

  /* @ts-ignore */
  if (bgColor === 'dark4') {
    bgColor = 'brand4';
  }

  /* @ts-ignore */
  if (bgColor === 'dark5') {
    bgColor = 'brand5';
  }

  /* @ts-ignore */
  if (bgColor === 'light1') {
    bgColor = 'default1';
  }

  /* @ts-ignore */
  if (bgColor === 'light2') {
    bgColor = 'default2';
  }
  if (!theme["box_color_background_".concat(bgColor)]) {
    bgColor = 'default1';
    console.warn("Background colour \"".concat(bgColor, "\" in Box component for brand \"").concat(brand, "\" is not available. Use an alternative colour."));
  }
  if (elevation !== 0) {
    if (!theme["elevation_".concat(elevation, "_css")]) {
      console.warn("Elevation value \"".concat(elevation, "\" in Box component for brand \"").concat(brand, "\" is not available."));
    } else {
      if (!theme["box_background_".concat(bgColor, "_elevation_").concat(elevation, "_css")]) {
        console.warn("Elevation value \"".concat(elevation, "\" in Box component is not available with \"").concat(bgColor, "\" background colour."));
      }
    }
  }
  return /*#__PURE__*/React.createElement(StyledBox, _extends({
    $bgColor: bgColor,
    $elevation: elevation,
    $marginBottom: marginBottom,
    $marginLeft: marginLeft,
    $marginRight: marginRight,
    $marginTop: marginTop,
    $padding: padding,
    className: className,
    ref: ref
  }, rest), bgColor !== 'none' ? /*#__PURE__*/React.createElement(BackgroundProvider, {
    value: {
      colorName: bgColor,
      cssValue: theme["box_color_background_".concat(bgColor)]
    }
  }, children) : children);
});
Box.displayName = 'Box';
export default Box;